import { render, staticRenderFns } from "./Casos.vue?vue&type=template&id=2ec6a420&"
import script from "./Casos.vue?vue&type=script&lang=js&"
export * from "./Casos.vue?vue&type=script&lang=js&"
import style0 from "./Casos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports